import { stringToNumber } from "@/helpers/utils";
import ColorTag from "./ColorTag";
import { Tooltip, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

interface Tag {
  name: string;
  description: string;
}

interface ColorTagsWithInfoProps {
  tags: Tag[];
}

const colors = ["blue", "orange", "yellow", "purple", "dark_green"];

const ColorTagsWithInfo = ({ tags }: ColorTagsWithInfoProps) => {
  if (!tags.length) return null;

  return (
    <Stack direction="row" gap="xs" wrap>
      {tags.map(tag => (
        <Tooltip
          title={
            <Stack direction="column" className="al-max-w-[300px] al-p-2">
              <Typography className="al-text-brand al-break-all">{tag.name}</Typography>
              <Typography variant="body" size="sm">
                {tag.description}
              </Typography>
            </Stack>
          }
          key={tag.name}
        >
          <div>
            <ColorTag
              color={colors[stringToNumber(tag.name, colors.length)]}
              label={tag.name}
              disableTruncation
            />
          </div>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default ColorTagsWithInfo;
